import createSagaMiddleware from 'redux-saga';
import {
  GlobalPut,
  integrateReduxDevtoolsExtension,
  NgRefreshStore,
  PS20Store,
} from '@ps20-frontend/shop-integration-redux';
import combineSectionReducers from 'combine-section-reducers';
import { App } from '@ps20-frontend/frontend-models';
import { configureStore, Dispatch, Middleware, Tuple, UnknownAction } from '@reduxjs/toolkit';

import { rootSaga } from './sagas/rootSaga';
import { INITIAL_STATE } from './initialState';
import { versicherungsnehmerReducer } from './reducers/versicherungsnehmer.reducer';
import { IAppState } from './toolbarState';
import { rootReducer } from './reducers/rootReducer.reducer';
import { aktiveRubrikReducer } from './reducers/aktiveRubrik.reducer';
import { rubrikenReducer } from './reducers/rubriken.reducer';
import { toolbarIsInteractiveReducer } from './reducers/toolbarIsInteractive.reducer';
import { zahlungsoptionenReducer } from './reducers/zahlungsoptionen.reducer';
import { gesamtpreisHiddenReducer } from './reducers/gesamtpreisHidden.reducer';
import { gesamtpreisReducer } from './reducers/gesamtpreis.reducer';
import { rbdReducer } from './reducers/rbd.reducer';
import { rbdModalOpenReducer } from './reducers/rbdModalOpen.reducer';
import { gesamtpreisPopoverReducer } from './reducers/gesamtpreisPopover.reducer';
import { speichernReducer } from './reducers/speichern.reducer';
import { transientStateReducer } from './reducers/transient-state.reducer';
import { treuebonusReducer } from './reducers/treuebonus.reducer';
import { vorliegendeKuendigungenReducer } from './reducers/vorliegendeKuendigungen.reducer';
import { aktionsNachlassReducer } from './reducers/aktionsNachlassReducer';
import { vorteilsrabattReducer } from './reducers/vorteilsrabatt.reducer';
import { accountManagerReducer } from './reducers/accountManager.reducer';

export const reducers = combineSectionReducers({
  version: (version: number = null) => version,
  versicherungsnehmer: versicherungsnehmerReducer,
  accountManager: accountManagerReducer,
  aktiveRubrik: aktiveRubrikReducer,
  rubriken: rubrikenReducer,
  gesamtpreis: gesamtpreisReducer,
  gesamtpreisHidden: gesamtpreisHiddenReducer,
  zahlungsoptionen: zahlungsoptionenReducer,
  rbd: rbdReducer,
  rbdModalOpen: rbdModalOpenReducer,
  gesamtpreisPopover: gesamtpreisPopoverReducer,
  speichern: speichernReducer,
  toolbarIsInteractive: toolbarIsInteractiveReducer,
  transientState: transientStateReducer,
  treuebonus: treuebonusReducer,
  vorliegendeKuendigungen: vorliegendeKuendigungenReducer,
  aktionsnachlassCode: aktionsNachlassReducer,
  vorteilsrabatt: vorteilsrabattReducer,
});

export function storeFactory(initialState: IAppState): PS20Store<IAppState> {
  const ngRefreshStore = new NgRefreshStore<IAppState>(App.SHOP_TOOLBAR);
  const sagaMiddleware = createSagaMiddleware();
  const store = configureStore({
    reducer: rootReducer(reducers),
    devTools: integrateReduxDevtoolsExtension('ps-nova-toolbar'),
    preloadedState: initialState,
    middleware: getDefaultMiddleware =>
      getDefaultMiddleware().concat(sagaMiddleware, ngRefreshStore.ngRefreshMiddleware) as unknown as Tuple<ReadonlyArray<Middleware<Record<string, never>, IAppState, Dispatch<UnknownAction>>>>,
  });
  sagaMiddleware.run(rootSaga);
  ngRefreshStore.setDelegate(store);
  return ngRefreshStore;
}

export const localStore: PS20Store<IAppState> = storeFactory(INITIAL_STATE);

GlobalPut.getInstance().globalEventDispatcherFunction = () => {
  return localStore.globalEventDispatcherRef;
};
